/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    disableAutoplay: PropTypes.bool,
};

const defaultProps = {
    title: '',
    url: '',
};

export default class Video extends React.Component {
    renderVideo() {
        if (this.props.disableAutoplay) {
            return (
                <div>
                    {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                    <video
                        controls
                        title={this.props.title}
                        width="420"
                        height="315"
                        style={{ maxWidth: '100%' }}
                        playsInline
                        src={this.props.url}
                        preload="metadata"
                    />
                </div>
            );
        }
        return (
            <div>
                <iframe
                    title={this.props.title}
                    width="420"
                    height="315"
                    src={this.props.url}
                    allowFullScreen
                />
            </div>
        );
    }

    render() {
        return (
            <div>
                <h3>{this.props.title}</h3>
                {this.renderVideo()}
            </div>
        );
    }
}

Video.propTypes = propTypes;
Video.defaultProps = defaultProps;
